import React from 'react'
import { ErrorBoundary, Provider } from '@rollbar/react'
import { useIdentity } from '@vp/auth-react'
import { createRollbarClient } from '../../configurations/rollbar'
import { useEnvContext } from '../../contexts/UbikEnvContext'

const RollbarProvider = (props: { children: React.ReactNode }) => {
  const { UBIK_ROLLBAR_BROWSER_TOKEN } = useEnvContext()
  const identity = useIdentity()
  const rollbarClient = createRollbarClient(identity.canonicalId, UBIK_ROLLBAR_BROWSER_TOKEN)
  if (rollbarClient) {
    //@ts-ignore
    window.rollbar = rollbarClient
  }
  return (
    <Provider instance={rollbarClient}>
      <ErrorBoundary>{props.children}</ErrorBoundary>
    </Provider>
  )
}

export default React.memo(RollbarProvider)
